import { FC } from 'react';
import { AboutContent } from './AboutContent';
import style from './CoatingAboutStyle.module.css';
import { PopupPageTemplate } from '@/components/uiParts/Template/PopupPageTemplate/PopupPageTemplate';

type CoatingAboutPopupProps = {
  showLink?: boolean;
};

export const CoatingAboutPopup: FC<CoatingAboutPopupProps> = ({
  showLink = true,
}) => {
  return (
    <PopupPageTemplate
      id="CoatingAboutPopup"
      title="ボディコーティング"
      pageName="CoatingAbout"
      closeWrapperClass={style['close-fixed']}
    >
      <AboutContent showLink={showLink} />
    </PopupPageTemplate>
  );
};
